import { createRoute, useNavigate } from '@tanstack/react-router'
import { useEffect } from 'react'

import { rootRoute } from './root'

export const fallbackMxRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: 'mx',
  component: () => {
    const navigate = useNavigate()

    useEffect(() => {
      navigate({ to: '/' })
    }, [])

    return null
  },
})
